import { Account, Client, Grant } from '../../types/management-auth';
import { ProfileConfiguration } from '../../types/checkout';

export enum ActionTypes {
    GetAccount = '[wizard/checkout] GET_ACCOUNT',
    FetchAccountResponse = '[wizard/checkout] FETCH_ACCOUNT_RESPONSE',
    ContinueWhilePending = '[wizard/checkout] CONTINUE_WHILE_PENDING',
    FetchClientsResponse = '[wizard/checkout] FETCH_CLIENTS_RESPONSE',
}

export interface GetAccount {
    type: ActionTypes.GetAccount;
    payload: {
        accountId: string;
    };
}

export function getAccount(accountId: string): GetAccount {
    return {
        type: ActionTypes.GetAccount,
        payload: {
            accountId,
        },
    };
}

export interface ContinueWhilePending {
    type: ActionTypes.ContinueWhilePending;
    payload: {
        accountId: string;
    };
}

export function continueWhilePending(accountId: string): ContinueWhilePending {
    localStorage.setItem(`checkout_wizard_continue_while_pending_${accountId}`, 'true');
    return {
        type: ActionTypes.ContinueWhilePending,
        payload: {
            accountId,
        },
    };
}
export interface FetchAccountResponse {
    type: ActionTypes.FetchAccountResponse;
    payload: {
        account: Account;
    };
    meta: {
        cause: GetAccount;
    };
}


export interface FetchClientsResponse {
    type: ActionTypes.FetchClientsResponse;
    payload: {
        clients: Client[];
        grants: { [client_id: string]: Grant[] };
    };
    meta: {
        cause: GetAccount;
    };
}

export type Actions =
    | GetAccount
    | FetchAccountResponse
    | FetchClientsResponse
    | ContinueWhilePending;
